import { Tag } from "antd";

interface Props {
    data: any
}
const EngagementTerms = (props: Props) => {
    const { data } = props;


    return (
        <div className="flex flex-col gap-y-[16px]">
            {data?.engagement_model && data?.engagement_model?.length > 0 ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Accepted Business Models</p>
                    {data?.engagement_model?.map((item: any, index: number) => (
                        <Tag bordered={false} key={index}>{item}</Tag>
                    ))}

                </div>
            ) : (
                <></>
            )}
            {data?.trading_terms ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Trading Terms</p>
                    <Tag bordered={false}>{data?.trading_terms}</Tag>
                </div>
            ) : (
                <></>
            )}
            {data?.minimum_tenure ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Minimum Exclusivity Tenure</p>
                    <Tag bordered={false}>{data?.minimum_tenure}</Tag>
                </div>
            ) : (
                <></>
            )}

            {data?.trade_marketing_investments ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Preference on Marketing Investment</p>
                    <Tag bordered={false}>{data?.trade_marketing_investments}</Tag>
                </div>
            ) : (
                <></>
            )}

            {data?.payment_terms && data?.payment_terms?.length > 0 ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Payment Terms</p>
                    {data?.payment_terms?.map((item: any, index: number) => (
                        <Tag bordered={false} key={index}>{item}</Tag>
                    ))}
                </div>
            ) : (
                <></>
            )}

            {data?.shipment_terms && data?.shipment_terms?.length > 0 ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Shipment Terms</p>
                    {data?.shipment_terms?.map((item: any, index: number) => (
                        <Tag bordered={false} key={index}>{item}</Tag>
                    ))}
                </div>
            ) : (
                <></>
            )}

        </div>
    )
}

export default EngagementTerms